module.exports = __webpack_public_path__ + "img/arrowbottom.3e951124.svg";